import { render, staticRenderFns } from "./documentomasivos.vue?vue&type=template&id=5447f46e&"
import script from "./documentomasivos.vue?vue&type=script&lang=js&"
export * from "./documentomasivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports